import React, { useState, useEffect, useRef } from "react"
import { withPrefix } from "gatsby"
import Layout from "../components/layout"
import Image from "../components/image"
import { PageColumns, Column } from "../components/page-column"
import Logo from "../components/svg/logo"
import MobileOnly from "../components/mobile-only"
import DownloadFullReport from "../components/download-full-report"
import downloadTranslations from "../data/download-translations.json"
import menu from "../data/menu.json"
import findObject from "../helpers/find-object"
import { useQueryParam, StringParam } from "use-query-params"
import { Helmet } from "react-helmet"

function DownloadUnit({ translation }) {
  return (
    <div className="downloads__report">
      <a
        href={withPrefix("/") + translation.download.href}
        className="downloads__report__image"
      >
        <Image
          path={translation.download.image}
          alt={translation.download.alt}
        />
      </a>
      <a
        className="cta--inverse downloads__report__button"
        href={withPrefix("/") + translation.download.href}
      >
        {translation.download.cta}
      </a>
    </div>
  )
}

export default function Downloads() {
  const [language] = useQueryParam("lang", StringParam)
  const textRef = useRef()
  const [languageRTL, setLanguageRTL] = useState(false)
  const [translation, setTranslation] = useState(
    findObject(downloadTranslations, "language", "en")
  )

  const downloadResources = findObject(
    menu,
    "name",
    "Downloads"
  ).children.filter(child => child.name !== "Download Full Report")

  useEffect(() => {
    let validTranslation = findObject(
      downloadTranslations,
      "language",
      language
    )

    if (validTranslation) {
      setTranslation(validTranslation)
      setLanguageRTL(validTranslation.language === "ar")
    }

    textRef.current.innerHTML = translation.text
  }, [language, translation])

  return (
    <Layout>
      <Helmet>
        <html lang={translation.language} />
      </Helmet>
      <section
        className={`page page--margin-small ${
          languageRTL ? "downloads downloads--rtl" : "downloads"
        }`}
      >
        <div className="container md:container--large">
          <header className="page__header">
            <div className="page__header__logo">
              <Logo />
              <h2 className="title--m md:title--l">
                {translation.annual_report}
              </h2>
            </div>
            <h1 className="title--xl md:title--xxl">{translation.header}</h1>
          </header>
        </div>

        <PageColumns modifiers="downloads__content">
          <Column type="text">
            <div ref={textRef} />
            <MobileOnly>
              <DownloadUnit translation={translation} />
            </MobileOnly>
          </Column>

          <Column type="media">
            <DownloadUnit translation={translation} />
          </Column>
        </PageColumns>

        <div
          className="container md:container--large"
          style={{
            paddingTop: 50,
            borderTop: "1px solid #dadada",
            marginTop: 80,
          }}
        >
          <h3 className="title title--l md:title--xl util__text-centered">
            {translation.resources}
          </h3>

          {downloadResources && (
            <div className="downloads__resources-list">
              <ul>
                {downloadResources.map((item, index) => (
                  <li key={`download-resources-${index}`}>
                    <a href={withPrefix("/") + item.href}>
                      {translation[item.name]}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          )}

          <DownloadFullReport
            location="page"
            title={translation.download_the_pdf_report}
          />
        </div>
      </section>
    </Layout>
  )
}
